import React, { useState } from "react";

const MobileEditModal = ({ reservation, tables, onClose, onSuccess }) => {
  const [guestName, setGuestName] = useState(reservation.guest_name);
  const [guests, setGuests] = useState(reservation.guests);
  const [note, setNote] = useState(reservation.note || "");
  const [tableLabel, setTableLabel] = useState(reservation.tables[0] || "");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const sortedTables = [...tables].sort((a, b) => a.label.localeCompare(b.label));

  const handleSave = async () => {
    if (!guestName.trim()) return setError("Unesi ime gosta!");
    setLoading(true);
    try {
      const response = await fetch(`/reservations/api/reservations/${reservation.id}/update/`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ guest_name: guestName, guests, note, table_label: tableLabel }),
      });
      if (response.ok) {
        onSuccess();
      } else {
        const data = await response.json();
        setError(data.error || "Greška pri spremanju.");
      }
    } catch {
      setError("Mrežna greška.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex flex-col">
      <div className="bg-gray-900 border-b border-[#c1b428] px-4 py-3 flex justify-between items-center">
        <h2 className="text-[#c1b428] font-bold text-base">Uredi rezervaciju</h2>
        <button onClick={onClose} className="text-gray-400 text-2xl">✕</button>
      </div>

      <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4">
        {error && <div className="p-3 bg-red-900 border border-[#c1b428] rounded text-[#c1b428] text-sm">{error}</div>}

        <div>
          <label className="block text-[#c1b428] text-sm font-semibold mb-1">Ime gosta:</label>
          <input type="text" value={guestName} onChange={e => setGuestName(e.target.value)}
            className="w-full bg-gray-800 text-white border border-[#c1b428] rounded-lg px-3 py-3 text-sm" />
        </div>

        <div>
          <label className="block text-[#c1b428] text-sm font-semibold mb-1">Broj osoba:</label>
          <input type="number" value={guests} onChange={e => setGuests(Number(e.target.value))} min="1"
            className="w-full bg-gray-800 text-white border border-[#c1b428] rounded-lg px-3 py-3 text-sm" />
        </div>

        <div>
          <label className="block text-[#c1b428] text-sm font-semibold mb-1">Stol:</label>
          <select value={tableLabel} onChange={e => setTableLabel(e.target.value)}
            className="w-full bg-gray-800 text-white border border-[#c1b428] rounded-lg px-3 py-3 text-sm">
            {sortedTables.map(t => (
              <option key={t.id} value={t.label}>{t.label} ({t.seats} mjesta)</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-[#c1b428] text-sm font-semibold mb-1">Napomena:</label>
          <textarea rows="2" value={note} onChange={e => setNote(e.target.value)}
            className="w-full bg-gray-800 text-white border border-[#c1b428] rounded-lg px-3 py-3 text-sm" />
        </div>
      </div>

      <div className="px-4 py-4 bg-gray-900 border-t border-gray-700 flex gap-3">
        <button onClick={onClose} className="flex-1 py-3 bg-gray-700 text-white rounded-lg font-semibold text-sm">
          Odustani
        </button>
        <button onClick={handleSave} disabled={loading}
          className="flex-1 py-3 bg-[#c1b428] text-black rounded-lg font-bold text-sm disabled:opacity-50">
          {loading ? "Spremanje..." : "Spremi"}
        </button>
      </div>
    </div>
  );
};

export default MobileEditModal;